import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./help-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./help-modal.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../constants/shared.constants";
import { AppConfig } from "../../../app.config";
let HelpModalComponent = class HelpModalComponent {
    activeModal;
    dialogTitle;
    helpMessage;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    closeBtnPlaceholder = "Close";
    constructor(activeModal) {
        this.activeModal = activeModal;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
    }
    onCloseBtnClicked() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        helpMessage: [{ type: Input }]
    };
};
HelpModalComponent = __decorate([
    Component({
        selector: "app-help-modal", template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], HelpModalComponent);
export { HelpModalComponent };
